module.exports = __webpack_public_path__ + "static/media/background-trening.e2726f84.png";